import { EventEmitter } from 'events';
import IOTService from '@services/IOT';
import UserService from '@services/UserService';
import Amplify from 'aws-amplify';
import{ AWSIoTProvider } from "@aws-amplify/pubsub";

class IOT {
    private readonly _service: IOTService;
    private readonly _userSvc: UserService;
    onReceive: EventEmitter;
    constructor() {
        this._service = new IOTService();
        this._userSvc = new UserService();
        this.onReceive = new EventEmitter();
    }

    async connect() {
        if (!await this._userSvc.isAuthenticated()) {
            return;
        }

        const endpoint = await this._service.connect();
        const regex = endpoint.match(/\.iot\.(.*)\.amazonaws\./g);
        if (!regex || regex.length == 0) {
            throw new Error('not possible extract region from endpoint IOT');
        }
        const region = regex[0].replace('.iot.', '').replace('.amazonaws.', '');
        console.log(`iot-endpoint (${region}): ${endpoint}`);
        Amplify.addPluggable(new AWSIoTProvider({
            aws_pubsub_region: region,
            aws_pubsub_endpoint: `wss://${endpoint}/mqtt`,
        }));
    }

    private onMessage(topic: string, payload: any) {
        this.onReceive.emit(topic, payload);
    }
        private onError(topic: string, err: Error | string) {
        console.log(`iot-error: ${topic}`);
        console.error(err);
    }

    subscribe(topic: string) {
        const self = this;
        const sub = Amplify.PubSub.subscribe(topic).subscribe({
            next: (data: any) => {
                self.onMessage(topic, data.value);
            },
            error: (err: any) => {
                self.onError(topic, err);
            }
        });
    };
    async publish(topic: string, data: any) {
        await Amplify.PubSub.publish(topic, data);
    };
};
export default new IOT();